import { z } from 'zod'

/** Enum permission for the profile. */
export const TypePermission = z.enum(['CREATE', 'DELETE', 'READ', 'UPDATE'])
export type TypePermission = z.infer<typeof TypePermission>

export const TypePermissionObject = z.object({
    CREATE: z.string().min(1),
    DELETE: z.string().min(1),
    READ: z.string().min(1),
    UPDATE: z.string().min(1),
})
export type TypePermissionObject = z.infer<typeof TypePermissionObject>

/** Enum action for the profile permissions. */
export const TypePermissionAction = z.enum(['ADD', 'REMOVE'])
export type TypePermissionAction = z.infer<typeof TypePermissionAction>

/** Permission to do a specific action in specific data. */
export const Permission = z.object({
    id: z.number().positive(),
    codename: z.string().min(1),
})

export type Permission = z.infer<typeof Permission>

/** Permissions list returned by the API */
const PermissionsRequest = z.object({
    count: z.number(),
    results: Permission.array(),
})

export type PermissionsRequest = z.infer<typeof PermissionsRequest>

const PermissionFieldObject = z.object({
    label: z.string().min(1),
    permissions: TypePermissionObject,
    isIndented: z.boolean().optional(),
    groupedWith: TypePermissionObject.array().optional(),
})

export type PermissionFieldObject = z.infer<typeof PermissionFieldObject>

export const PermissionField = z.object({
    label: z.string(),
    permissionsList: PermissionFieldObject.array(),
})

export type PermissionField = z.infer<typeof PermissionField>
